<annotated-control [field]="field">
  @for (value of values; track value; let last = $last) {
  <div class="inputs">
    @for (option of options; track option; let i = $index) {
    <div class="input">
      @if (option.display_type === 'number') {
      <input
        type="number"
        [(ngModel)]="value[i]"
        (change)="propagateValueChange()"
        [disabled]="disabled"
        class="form-control"
      />
      } @if (option.display_type === 'select') {
      <basic-select
        [value]="value[i]"
        (valueChange)="value[i] = $event; propagateValueChange()"
        [disabled]="disabled"
        [options]="option.items"
      ></basic-select>
      }
    </div>
    } @if (!disabled) {
    <array-field-controls
      [canRemove]="canRemove"
      [canAdd]="last"
      (add)="addEmptyValue()"
      (remove)="removeValue(value)"
    ></array-field-controls>
    }
  </div>
  }
</annotated-control>
